import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query';
import { showErrorNotification } from './common';
import { AxiosError } from 'axios';

const defaultErrorHandler = (error: AxiosError) => {
  let errorMessage;
  if (error?.response?.data) {
    errorMessage =
      error.response.data?.message || error.response.data?.error?.message;
  } else {
    errorMessage = error.message;
  }
  showErrorNotification(errorMessage);
  if (error?.response?.status === 401) {
    localStorage.clear();
    window.location.href = '/auth/sign-in';
  }
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
      initialDataUpdatedAt: new Date('2019-01-01'),
    },
  },
  queryCache: new QueryCache({
    onError: defaultErrorHandler,
  }),
  mutationCache: new MutationCache({
    onError: defaultErrorHandler,
  }),
});

export default queryClient;
